import { useAppSelector } from 'store/hooks';
import { lazy, useEffect, useState } from 'react';
import { UserAuth } from 'store/auth';
const Home = lazy(() => import('app/home'));

export default function HomeRouteWrapper(props: any) {
    const userAuth: UserAuth = useAppSelector((state) => state.auth);
    const [showHomePage, setShowHomePage] = useState<boolean>(false);
    useEffect(() => {
        if (userAuth.userInfo?.homeUrl && userAuth.userInfo?.homeUrl != '/home') {
            window.location.href = userAuth.userInfo.homeUrl;
        } else {
            setShowHomePage(true);
        }
    }, [userAuth.userInfo?.homeUrl]);
    return showHomePage ? <Home {...props} /> : null;
}
